module.exports = __webpack_public_path__ + "img/kaduna-shield.e91857f2.png";